<template>
  <div class="login-wrapper" v-loading="loading">
    <div class="login-card">
      <div class="card-body">
        <!-- 左栏：Logo -->
        <div class="card-left">
          <img :src="ossPath + 'logo.gif'" class="logo-img" alt="幻之大地">
        </div>

        <!-- 右栏：注册表单 -->
        <div class="card-right">
          <el-form :model="loginForm" ref="loginForm" label-position="top" class="login-form">
            <el-form-item prop="userName">
              <el-input
                type="text"
                v-model="loginForm.userName"
                placeholder="请输入账号"
                prefix-icon="el-icon-user"
              ></el-input>
            </el-form-item>

            <el-form-item prop="nickName">
              <el-input
                type="text"
                v-model="loginForm.nickName"
                placeholder="请输入昵称"
                prefix-icon="el-icon-edit"
              ></el-input>
            </el-form-item>

            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="loginForm.password"
                placeholder="请输入密码"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>

            <el-form-item prop="repassword">
              <el-input
                type="password"
                v-model="loginForm.repassword"
                placeholder="请再输入密码"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>

            <el-form-item prop="email">
              <el-input
                type="email"
                v-model="loginForm.email"
                placeholder="请输入邮箱"
                prefix-icon="el-icon-message"
              ></el-input>
            </el-form-item>

            <!-- 验证码区域 -->
            <el-form-item prop="captcha" class="captcha-form-item">
              <div class="captcha-row">
                <el-input
                  type="text"
                  class="captcha-input"
                  maxlength="4"
                  v-model="loginForm.captcha"
                  @keyup.enter.native="submitClick"
                  placeholder="请输入验证码"
                ></el-input>
                <img
                  class="captcha-img"
                  alt="点击更换"
                  title="点击更换"
                  @click="changeCode"
                  :src="codeImgSrc"
                />
              </div>
            </el-form-item>

            <!-- 注册按钮 -->
            <el-form-item class="submit-form-item">
              <el-button
                type="primary"
                class="login-btn"
                :loading="loading"
                @click.native.prevent="submitClick"
              >注 册</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <!-- 底部导航链接 -->
      <div class="nav-links">
        <router-link :to="{name:'login'}" class="nav-link">返回登录</router-link>
        <span class="nav-divider">|</span>
        <router-link :to="{name:'about'}" class="nav-link">关于幻地</router-link>
        <span class="nav-divider">|</span>
        <router-link :to="{name:'guideIndex'}" class="nav-link">旅游指南</router-link>
        <span class="nav-divider">|</span>
        <router-link :to="{name:'version'}" class="nav-link">版本说明</router-link>
      </div>
    </div>

    <!-- Footer -->
    <div class="login-footer">
      <div class="copyright">
        ©Copyright 2019 <a href="http://www.huanzhidadi.com" target="_blank">幻之大地</a> ALL RIGHTS RESERVED. <a href="https://beian.miit.gov.cn" target="_blank" title="豫ICP备17045248号-3">豫ICP备17045248号-3</a>
      </div>
      <div class="advice">
        抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。<br/>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
      </div>
    </div>
  </div>
</template>
<script>
  import {postRequest, postJson} from '../utils/api'
  import {putRequest} from '../utils/api'
  import {getRequest} from '../utils/api'
  import Message from 'element-ui/lib/message'
  export default{
    data(){
      return {
        // rules: {
        //   username: [{required: true, message: '', trigger: 'blur'}],
        //   password: [{required: true, message: '', trigger: 'blur'}],
        //   captcha: [
        //     {required: true, message: '', trigger: 'blur'},
        //     {min: 4, max: 4, message: '', trigger: 'blur'},
        //   ],
        // },
        // checked: true,
        loginForm: {
          userName: '',
          nickName: '',
          password: '',
          repassword: '',
          email: '',
          captcha: ''
        },
        loading: false,
        codeImgSrc: '',
        errorinfo: '',
        captchaItem: false,
      }
    },
    methods: {
      checkInput: function(_this) {
        if (_this.loginForm.userName=="") {
          Message.error('用户名不能为空！');
          return false;
        }
        if (_this.loginForm.nickName=="") {
          Message.error('昵称不能为空！');
          return false;
        }
        if (_this.loginForm.password=="") {
          Message.error('密码不能为空！');
          return false;
        }
        if (_this.loginForm.repassword=="") {
          Message.error('确认密码不能为空！');
          return false;
        }
        if (_this.loginForm.email=="") {
          Message.error('邮箱地址不能为空！');
          return false;
        }
        if (_this.loginForm.repassword != _this.loginForm.password) {
          Message.error('两次输入的密码不一致！');
          return false;
        }
        if (_this.loginForm.captcha=="") {
          Message.error('验证码不能为空！');
          return false;
        }
        return true;
      },
      submitClick: function () {
        var _this = this;
        var result = this.$options.methods.checkInput(_this);
        if (result == true) {
          this.$confirm('请确认您的账号，这是您以后进入这个世界的登陆名，一旦确定<span style="color:red">不能</span>再进行修改，同时请确认<span style="color:red">邮箱地址</span>的正确性，' +
          '稍后我们会向您的邮箱发送一封<span style="color:red">验证邮件</span>，通过验证后才算注册成功哦。', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '再看看',
              dangerouslyUseHTMLString:true,
              type: 'warning'
          }).then(function () {
            _this.loading = true;
            postJson('/auth/login/registerUser', {
              userName: _this.loginForm.userName,
              nickName: _this.loginForm.nickName,
              password: _this.loginForm.password,
              email: _this.loginForm.email,
              imgCode: _this.loginForm.captcha
            }).then(resp=> {
              _this.loading = false;
              if (resp.status == 200) {
                //成功
                var respData = resp.data;
                if (200 == respData.status) {
                  Message.success("注册成功，请查收验证邮件：点击邮件中的链接，或输入邮件中的6位验证码完成验证。");
                  _this.$router.replace({path: '/'});
                } else {
                  Message.error(respData.message);
                  _this.changeCode();
                }
              } else {
                //失败
                Message.error('登录失败!');
              }
            }, resp=> {
              _this.loading = false;
              Message.error('找不到服务器⊙﹏⊙∥!');
            });
          }, function () {
              //取消
          })
        }
        
      },
      genTimestamp: function() {
        var time = new Date();
        return time.getTime();
      },
      changeCode: function() {
        var _this = this;
        postRequest('/auth/login/getCaptcha', {
        }).then(resp=> {
          if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
              _this.codeImgSrc = "data:image/jpg;base64," + respData.data
            } else {
              Message.error(respData.message);
              _this.changeCode();
            }

          } else {
            //失败
            Message.error('验证码获取失败!');
          }
        }, resp=> {
          Message.error('找不到服务器⊙﹏⊙∥!');
        });
      }
    },
    mounted: function() {
      this.changeCode();
    },
  }
</script>
<style scoped>

/* ========== 页面容器 ========== */
.login-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f0f2f5;
  padding: 40px 16px;
  box-sizing: border-box;
}

/* ========== 登录卡片 ========== */
.login-card {
  width: 100%;
  max-width: 720px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.04);
  padding: 36px 40px;
  box-sizing: border-box;
}

/* ========== 卡片主体：左右栏 ========== */
.card-body {
  display: flex;
  align-items: flex-start;
}

.card-left {
  flex: 0 0 42%;
  text-align: center;
  padding-right: 32px;
  padding-top: 20px;
}

.card-right {
  flex: 1;
  min-width: 0;
}

/* ========== Logo ========== */
.logo-img {
  max-width: 100%;
  height: auto;
  display: inline-block;
}

/* ========== 表单 ========== */
.login-form {
  margin-top: 0;
}

.login-form .el-form-item {
  margin-bottom: 16px;
}

.login-form .el-input__inner {
  border-radius: 8px;
  height: 42px;
  line-height: 42px;
  font-size: 15px;
}

/* ========== 验证码区域 ========== */
.captcha-form-item {
  margin-bottom: 16px;
}

.captcha-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.captcha-input {
  flex: 1;
}

.captcha-img {
  width: 110px;
  height: 42px;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  flex-shrink: 0;
  object-fit: contain;
  background: #fafafa;
  transition: border-color 0.2s;
}

.captcha-img:hover {
  border-color: #409eff;
}

/* ========== 注册按钮 ========== */
.submit-form-item {
  margin-bottom: 0;
}

.login-btn {
  width: 100%;
  height: 46px;
  border-radius: 8px;
  font-size: 16px;
  letter-spacing: 6px;
}

/* ========== 底部导航链接 ========== */
.nav-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-top: 16px;
  margin-top: 16px;
  border-top: 1px solid #ebeef5;
}

.nav-link {
  font-size: 13px;
  color: #606266;
  text-decoration: none;
  padding: 4px 6px;
  transition: color 0.2s;
  white-space: nowrap;
}

.nav-link:hover {
  color: #409eff;
}

.nav-divider {
  color: #dcdfe6;
  font-size: 14px;
  user-select: none;
}

/* ========== Footer ========== */
.login-footer {
  text-align: center;
  margin-top: 28px;
  padding: 0 16px;
}

.login-footer .copyright {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
}

.login-footer .copyright a {
  color: #909399;
  text-decoration: none;
  transition: color 0.2s;
}

.login-footer .copyright a:hover {
  color: #409eff;
}

.login-footer .advice {
  font-size: 11px;
  color: #aaa;
  line-height: 1.7;
  margin-top: 6px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .login-wrapper {
    padding: 12px 10px;
    justify-content: flex-start;
    padding-top: 16px;
  }

  .login-card {
    max-width: 360px;
    width: 92%;
    padding: 20px 16px;
    border-radius: 12px;
  }

  .card-body {
    flex-direction: column;
  }

  .card-left {
    flex: 0 0 auto;
    width: 100%;
    text-align: center;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 12px;
  }

  .logo-img {
    max-width: 100px;
  }

  .login-form .el-form-item {
    margin-bottom: 8px;
  }

  .login-form .el-input__inner {
    height: 36px;
    line-height: 36px;
    font-size: 14px;
  }

  .captcha-img {
    width: 90px;
    height: 36px;
  }

  .login-btn {
    height: 40px;
    font-size: 15px;
    letter-spacing: 4px;
    margin-top: 4px;
  }

  .nav-links {
    padding-top: 12px;
    margin-top: 10px;
    gap: 2px;
  }

  .nav-link {
    font-size: 12px;
    padding: 2px 4px;
  }

  .login-footer {
    margin-top: 12px;
  }

  .login-footer .copyright {
    font-size: 10px;
  }

  .login-footer .advice {
    font-size: 10px;
  }
}
</style>
